
const MembershipSection = () => {
  const membershipTiers = [
    {
      name: '一般會員',
      icon: 'ri-user-line',
      color: 'gray',
      benefits: [
        '報名過一次營隊即可第1次回流',
        '暑假可享回流折扣制度',
        '寒假可享回流折扣制度',
        '單一天優惠價700元'
      ],
      discounts: {
        summer: '第1次回流折1000元',
        winter: '第1次回流折500元'
      }
    },
    {
      name: '銀級會員',
      icon: 'ri-medal-line',
      color: 'gray',
      benefits: [
        '報名過一次營隊即可第2次回流',
        '暑假可享回流折扣制度',
        '寒假可享回流折扣制度',
        '單一天優惠價700元'
      ],
      discounts: {
        summer: '第2次回流折2000元',
        winter: '第2次回流折1000元'
      }
    },
    {
      name: '金級會員',
      icon: 'ri-vip-crown-line',
      color: 'yellow',
      benefits: [
        '報名過一次營隊即可第3次回流',
        '暑假可享回流折扣制度',
        '寒假可享回流折扣制度',
        '單一天優惠價650元'
      ],
      discounts: {
        summer: '第3次回流折4000元',
        winter: '第3次回流折1000元'
      }
    },
    {
      name: '白金會員',
      icon: 'ri-vip-diamond-line',
      color: 'blue',
      benefits: [
        '報名過一次營隊即可第4次回流',
        '暑假可享回流折扣制度',
        '寒假可享回流折扣制度',
        '單一天優惠價600元'
      ],
      discounts: {
        summer: '第4次回流折6000元',
        winter: '第4次回流折1500元'
      }
    },
    {
      name: '鑽石會員',
      icon: 'ri-gem-line',
      color: 'purple',
      benefits: [
        '報名過一次營隊即可第5次回流',
        '暑假可享回流折扣制度',
        '寒假可享回流折扣制度',
        '單一天優惠價550元'
      ],
      discounts: {
        summer: '第5次回流折8000元',
        winter: '第5次回流折2000元'
      }
    }
  ];

  const getColorClasses = (color: string) => {
    switch (color) {
      case 'gray':
        return {
          bg: 'bg-gray-100',
          icon: 'text-gray-600',
          border: 'border-gray-200',
          accent: 'text-gray-700'
        };
      case 'yellow':
        return {
          bg: 'bg-yellow-100',
          icon: 'text-yellow-600',
          border: 'border-yellow-200',
          accent: 'text-yellow-700'
        };
      case 'blue':
        return {
          bg: 'bg-blue-100',
          icon: 'text-blue-600',
          border: 'border-blue-200',
          accent: 'text-blue-700'
        };
      case 'purple':
        return {
          bg: 'bg-purple-100',
          icon: 'text-purple-600',
          border: 'border-purple-200',
          accent: 'text-purple-700'
        };
      default:
        return {
          bg: 'bg-gray-100',
          icon: 'text-gray-600',
          border: 'border-gray-200',
          accent: 'text-gray-700'
        };
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-emerald-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            會員制度
          </h3>
          <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
            參加CMAP營隊即可成為會員，享受專屬優惠與回流折扣，讓孩子持續成長學習
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 mb-12">
          {membershipTiers.map((tier, index) => {
            const colors = getColorClasses(tier.color);
            return (
              <div
                key={index}
                className={`bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border-2 ${colors.border} hover:scale-105`}
              >
                <div className="text-center mb-6">
                  <div className={`w-16 h-16 flex items-center justify-center ${colors.bg} rounded-full mx-auto mb-4`}>
                    <i className={`${tier.icon} ${colors.icon} text-2xl`}></i>
                  </div>
                  <h4 className={`text-xl font-bold ${colors.accent} mb-2`}>{tier.name}</h4>
                </div>

                <div className="space-y-3 mb-6">
                  {tier.benefits.map((benefit, benefitIndex) => (
                    <div key={benefitIndex} className="flex items-start space-x-2">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-check-line text-emerald-600 text-sm"></i>
                      </div>
                      <span className="text-sm text-gray-700 leading-relaxed">{benefit}</span>
                    </div>
                  ))}
                </div>

                <div className={`${colors.bg} rounded-xl p-4`}>
                  <h5 className={`font-semibold ${colors.accent} mb-2 text-sm`}>專屬折扣</h5>
                  <div className="space-y-1">
                    <p className="text-xs text-gray-600">
                      <strong>暑假：</strong>{tier.discounts.summer}
                    </p>
                    <p className="text-xs text-gray-600">
                      <strong>寒假：</strong>{tier.discounts.winter}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="bg-white rounded-2xl p-8 shadow-lg">
          <div className="text-center mb-8">
            <h4 className="text-2xl font-bold text-gray-900 mb-4 flex items-center justify-center">
              <div className="w-8 h-8 flex items-center justify-center mr-3 text-emerald-600">
                <i className="ri-gift-line text-2xl"></i>
              </div>
              團報優惠方案
            </h4>
            <p className="text-gray-600">兄弟姊妹團報第二名以上享原價優惠</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-r from-emerald-50 to-green-50 rounded-xl p-6">
              <h5 className="text-lg font-bold text-emerald-700 mb-4 flex items-center">
                <div className="w-6 h-6 flex items-center justify-center mr-2">
                  <i className="ri-group-line"></i>
                </div>
                團報說明
              </h5>
              <div className="space-y-3 text-sm text-gray-700">
                <div className="flex items-start">
                  <div className="w-4 h-4 flex items-center justify-center mr-2 mt-0.5 flex-shrink-0">
                    <i className="ri-arrow-right-s-line text-emerald-600"></i>
                  </div>
                  <span>第一名可選擇早鳥專案或會員制度</span>
                </div>
                <div className="flex items-start">
                  <div className="w-4 h-4 flex items-center justify-center mr-2 mt-0.5 flex-shrink-0">
                    <i className="ri-arrow-right-s-line text-emerald-600"></i>
                  </div>
                  <span>第二名以上享原價優惠</span>
                </div>
                <div className="flex items-start">
                  <div className="w-4 h-4 flex items-center justify-center mr-2 mt-0.5 flex-shrink-0">
                    <i className="ri-arrow-right-s-line text-emerald-600"></i>
                  </div>
                  <span>限報名2個月課程</span>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6">
              <h5 className="text-lg font-bold text-blue-700 mb-4 flex items-center">
                <div className="w-6 h-6 flex items-center justify-center mr-2">
                  <i className="ri-information-line"></i>
                </div>
                注意事項
              </h5>
              <div className="space-y-3 text-sm text-gray-700">
                <div className="flex items-start">
                  <div className="w-4 h-4 flex items-center justify-center mr-2 mt-0.5 flex-shrink-0">
                    <i className="ri-check-line text-blue-600"></i>
                  </div>
                  <span>自動累積，不需申請</span>
                </div>
                <div className="flex items-start">
                  <div className="w-4 h-4 flex items-center justify-center mr-2 mt-0.5 flex-shrink-0">
                    <i className="ri-check-line text-blue-600"></i>
                  </div>
                  <span>僅金會員用，請擇無效</span>
                </div>
                <div className="flex items-start">
                  <div className="w-4 h-4 flex items-center justify-center mr-2 mt-0.5 flex-shrink-0">
                    <i className="ri-check-line text-blue-600"></i>
                  </div>
                  <span>平日營隊課程和會員制度是最划算</span>
                </div>
                <div className="flex items-start">
                  <div className="w-4 h-4 flex items-center justify-center mr-2 mt-0.5 flex-shrink-0">
                    <i className="ri-check-line text-blue-600"></i>
                  </div>
                  <span>限報名2個月課程</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MembershipSection;
